import { render, staticRenderFns } from "./Preferences.vue?vue&type=template&id=575192e0&scoped=true&"
import script from "./Preferences.vue?vue&type=script&lang=js&"
export * from "./Preferences.vue?vue&type=script&lang=js&"
import style0 from "./Preferences.vue?vue&type=style&index=0&id=575192e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575192e0",
  null
  
)

export default component.exports